import React, { useEffect } from 'react';
import './instructions.css';

function Instructions() {
  useEffect(() => {
    const instructionsContainer = document.querySelector('.instructions-container');
    if (instructionsContainer) {
      instructionsContainer.style.paddingTop = '80px';
    }
  }, []);

  return (
    <div className="instructions-container">
      <div className="instructions-section">
        <h2>Supreme & Nike Bot Instructions</h2>

        {/* NEW WARNING SECTION HERE */}
        <div className="instruction-step">
          <h3>⚠️ Windows Defender / Antivirus Warning</h3>
          <p>
            When downloading the bot, Windows Defender or other antivirus software may mistakenly flag it as a virus and automatically delete the file. 
            <strong> This is a false positive.</strong> We promise that the bot is safe to use and does not contain any malicious code.
          </p>
          <p>
            If this happens, please disable your antivirus temporarily, then redownload the bot. Once installed, you can re-enable your antivirus software.
          </p>
        </div>

        <div className="instruction-step">
          <h3>Step 1: Login</h3>
          <p>
            Log in to your account using your credentials.
          </p>
        </div>

        <div className="instruction-step">
          <h3>Step 2: Access the Bot</h3>
          <p>
            Click the "Bot" button located at the top right of the screen.  
            <br />
            <strong>Note:</strong> It may take up to **3 minutes** for the bot's backend to fully load before the page appears. Please be patient!
          </p>
        </div>

        <div className="instruction-step">
          <h3>Step 3: Enter Your Information</h3>
          <p>
            Type all of your required information into the provided text inputs. This includes your shipping address, payment details, and any other necessary information.
          </p>
          <p>
            <strong>Size Input:</strong>
            <ul>
              <li>Leave the "size" input blank if the item you are purchasing does not have a size.</li>
              <li>If the item does have a size, type the "size" exactly as it is spelled on the Supreme or Nike website.</li>
            </ul>
          </p>
        </div>

        <div className="instruction-step">
          <h3>Step 4: Copy and Paste Item Link</h3>
          <p>
            Copy and paste the URL of the Supreme or Nike item you wish to purchase into the designated field.
          </p>
        </div>

        <div className="instruction-step">
          <h3>Step 5: Run the Bot</h3>
          <p>
            Click the "Run Bot" button to initiate the automated purchase process. The bot will then attempt to complete your purchase.
          </p>
        </div>

        <div className="instruction-step">
          <h3>Step 6: Success!</h3>
          <p>
            If successful, you'll receive a confirmation notification. You can then check your email for order details.
          </p>
        </div>

        <div className="instruction-step">
          <h3>Tips and Best Practices</h3>
          <ul>
            <li>
              <strong>Pre-Enter Information:</strong> Ensure you type in all your information before the drop, as we do not store your credentials for security reasons.
            </li>
            <li>
              <strong>Prepare Supreme/Nike Website:</strong> Have the Supreme or Nike website loaded and ready at least 5 minutes before the drop time.
            </li>
            <li>
              <strong>Use Proxies:</strong> To avoid IP bans, consider using proxies.
            </li>
            <li>
              <strong>Test Bot:</strong> Before a major drop, test the bot and your inputs to ensure they are working correctly.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Instructions;

